import React, { useCallback } from 'react'
import SkillfitLogo from '../../components/SkillfitLogo/SkillfitLogo'

import SetPasswordForm from '../../components/userAndGroupForms/SetPasswordForm/SetPasswordForm'
import { useSession } from '../../state/session'
import useRoutes from '../../state/useRoutes'
import useQueryParameters, { queryParameters } from '../../utilities/useQueryParameters'

import styles from './PasswordResetPage.module.scss'

const passwordResetQueryParams = queryParameters().string('token').string('email')

export default React.memo(function PasswordResetPage() {
  const routes = useRoutes()
  const { logout } = useSession()

  const { token, email } = useQueryParameters(passwordResetQueryParams)

  const handleSuccess = useCallback(async () => {
    await logout()
    routes.dashboard.goto({})
  }, [logout, routes])

  return (
    <div className={styles.PasswordResetPage}>
      <div>
        <SkillfitLogo className={styles.logo} />
        <SetPasswordForm emailOrUsername={email} token={token} onSuccess={handleSuccess} />
      </div>
    </div>
  )
})
